import * as types from '../types';
const selectMultipleChoiceExerciseOption = (exerciseId, option) => ({
  exerciseId,
  option,
  type: types.SELECT_MULTIPLE_CHOICE_EXERCISE_OPTION
});
export default selectMultipleChoiceExerciseOption;